import { Box } from '@mui/material';

import { thumbnailPlaceholder } from '@/assets';
import { Skeleton } from '@/components';

import { EpisodeCardMediumDimensions } from '../../constants';
import { episodeCardStyles } from '../../styles';

export const EpisodeCardMediumPlaceholder = () => {
  return (
    <Box
      sx={{
        border: 2,
        borderStyle: 'dashed',
        borderColor: 'grey75',
        borderRadius: episodeCardStyles.cover.borderRadius,
        width: EpisodeCardMediumDimensions.width,
        height: EpisodeCardMediumDimensions.height,
        overflow: 'hidden',
      }}>
      <Box
        sx={{
          p: 2,
          width: EpisodeCardMediumDimensions.coverImageWidth,
          height: EpisodeCardMediumDimensions.coverImageHeight,
        }}>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundColor: 'grey50',
            borderRadius: episodeCardStyles.cover.borderRadius,
            mb: 2,
          }}>
          <Box
            component="img"
            src={thumbnailPlaceholder}
            sx={{
              width: '60%',
              height: '100%',
              margin: 'auto',
              display: 'block',
            }}
          />
        </Box>
        <>
          <Skeleton height={16} animation={false} />
          <Skeleton width="80%" height={16} animation={false} />
          <Skeleton width="80%" height={16} animation={false} />
        </>
      </Box>
    </Box>
  );
};
